import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { EVENT_ACTIONS, EVENT_TYPES } from "./actions";
import {
  getEvent as APIgetEvent,
  getEvents as APIgetEvents,
  createEvent as APIcreateEvent,
  updateEvent as APIupdateEvent,
  deleteEvent as APIdeleteEvent
} from "../../services/api/events";
import { createNavigateTo, navigateTo } from "../navigation/saga";
import { eventsFilters } from "./selectors";
import { PREFERENCES_ACTIONS } from "../preferences/actions";

export function* watchEventsActions() {
  yield all([takeEvery(EVENT_TYPES.LOAD_ALL_REQUEST, getEvents)]);
  yield all([takeEvery(EVENT_TYPES.LOAD_REQUEST, getEvent)]);
  yield all([takeEvery(EVENT_TYPES.CREATE_REQUEST, createEvent)]);
  yield all([takeEvery(EVENT_TYPES.UPDATE_REQUEST, updateEvent)]);
  yield all([takeEvery(EVENT_TYPES.DELETE_REQUEST, deleteEvent)]);
  yield all([
    takeEvery(EVENT_TYPES.UPDATE_SUCCESS, createNavigateTo("/admin/events"))
  ]);
  yield all([takeEvery(EVENT_TYPES.CREATE_SUCCESS, getEvents)]);
  yield all([takeEvery(EVENT_TYPES.DELETE_SUCCESS, getEvents)]);
  yield all([takeEvery(EVENT_TYPES.UPDATE_FILTERS, getEvents)]);
}

function* getEvents(action) {
  try {
    const filters = yield select(eventsFilters);
    const events = yield call(APIgetEvents, filters);
    yield put(EVENT_ACTIONS.loadAllSuccess(events));
  } catch (e) {
    yield put(EVENT_ACTIONS.loadAllFailure(e));
  }
}

function* getEvent(action) {
  const { id } = action.payload;
  try {
    const event = yield call(APIgetEvent, id);
    yield put(EVENT_ACTIONS.loadSuccess(event));
  } catch (e) {
    yield put(EVENT_ACTIONS.loadFailure(e));
  }
}

function* createEvent(action) {
  const { values, redirect } = action.payload;
  try {
    const event = yield call(APIcreateEvent, values);
    yield put(EVENT_ACTIONS.createSuccess(event));
    if (redirect) {
      yield put(PREFERENCES_ACTIONS.setPreference("selectedEvent", event));
      yield call(navigateTo, "/admin/periods");
    }
  } catch (e) {
    yield put(EVENT_ACTIONS.createFailure(e));
  }
}

function* updateEvent(action) {
  const { id, values } = action.payload;
  try {
    const event = yield call(APIupdateEvent, id, values);
    yield put(EVENT_ACTIONS.updateSuccess(event));
  } catch (e) {
    yield put(EVENT_ACTIONS.updateFailure(e));
  }
}

function* deleteEvent(action) {
  const { id } = action.payload;
  try {
    const event = yield call(APIdeleteEvent, id);
    yield put(EVENT_ACTIONS.deleteSuccess(event));
  } catch (e) {
    yield put(EVENT_ACTIONS.deleteFailure(e));
  }
}
